"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _reactRouterDom = require("react-router-dom"),
    _queryString = _interopRequireDefault(require("query-string")),
    _clientAuth = require("@devsta/client-auth");

function skipComponent(queryParams, userIsRequired) {
  var _credentials$get = _clientAuth.credentials.get(),
      auth = _credentials$get.auth,
      user = _credentials$get.user,
      isAnonymous = (user || {}).isAnonymous;

  if (userIsRequired) return !1;

  var parsed = _queryString["default"].parse(queryParams);

  return !auth && null === parsed.p || auth && isAnonymous;
}

function withPublicLink(Component) {
  return (0, _reactRouterDom.withRouter)(function (props) {
    var location = props.location,
        children = props.children,
        userIsRequired = props.userIsRequired;
    return skipComponent(location.search, userIsRequired) ? children : _react["default"].createElement(Component, props, children);
  });
}

var _default = withPublicLink;
exports["default"] = _default;